import styled from 'styled-components';

export const StyledList = styled.ul`
  width: 100%;
`;

StyledList.displayName = 'StyledList';

export const StyledListItem = styled.li`
  & + & {
    margin-top: 4rem;
  }
`;

StyledListItem.displayName = 'StyledListItem';
